export default {
  home: {
    title: 'Home',
    customerService: 'Service Hotline',
    email: 'Email',
    eventTicketPurchase: 'TICKETS',
    eventVenues: 'VENUES',
    eventSearch: 'Search',
    ticketHolderNotice: 'Instructions',
    ticketNotice: 'Follow Us On',
    helpCenter: 'Help',
    registerNow: 'Log In',
    turn: '-'
  },
  show:{
    title: 'Event Details',
    audience: 'Spectators',
  },
  order:{
    noOrder: 'No Orders',
    present:'Transfer',
    refunding:'In refund',
    refunded:'Refunded ticket',
    idType: 'ID Document Type ',
    idNumber: 'ID Document No.',
    pageHome: 'Home',
    pageCenter: 'My account',
    pageOrder: 'My Orders',
    pageOrderNo: 'Order No.',
    payleft: 'Please pay in',
    topay: 'Pay',
    myOrder: 'My Orders',
    address: 'Delivery Address',
    orderNo: 'Order No',
    createTime: 'Order time',
    orderDetail: 'Details',
    seatPlanUnit: 'Ticket(s)',
    orderTipFirst: 'Please make the payment in',
    orderTipLast: ' or the order will be cancelled',
    orderInfo: 'Order Information',
    viewTicket: 'View Ticket Collection Code',
    viewTicket2: 'View E-Tickets',
    ticketDesc: 'Please scan the QR code and use WeChat mini program to view the e-ticket',
    waitPay: 'Unpaid',
    cancelOrder: 'Cancel the order',
    audience: 'Spectator',
    deliverMethod: 'Collection method',
    ticketIntro: 'Instructions',
    viewExpress: 'Track',
    payInfo: 'Payment information',
    payMethod: 'Payment method ',
    payTime: 'Order time',
    applyInvoice: 'Invoice',
    applyInvoiced: 'Invoice',
    orderDetails: 'Price',
    orderTotal: 'Total order amount',
    orderCancel: 'Are you sure to cancel the order?',
    success: 'Submitted',
  },
  payment: {
    select_pay_way:'Select payment method',
    quick_pay_money:'Please make the payment as soon as possible',
    your_order_created:'Your order has been generated',
    order_auto_close:' or the order will be cancelled',
    scan_pay:'Scan to Pay',
    open_phone:'please open ',
    open_phone_on: '',
    scan_finish_pay:'app and scan to pay (CNY)',
    pay_now:'PAY',
    weixin:'Wechat Pay',
    zhifubao:'Alipay',
    unitePay: 'WeChat/Alipay',
    eRmb: 'E-CNY',
  },
  invoice: {
    invoiceType: 'Type',
    invoiceTitleType: 'Title Type',
    invoiceTitle: 'Title',
    invoiceAmount: 'Amount',
    taxpayerId: 'TIN',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account Number',
    address: 'Company Registered Address',
    phoneNo: 'Company Tel.',
    invoiceContentType: 'Details',
    applyTime: 'Date of application',
    invoiceContentDesc: 'Sports Services',
    INDIVIDUAL_OR_INSTITUTION: 'Individual or Organization',
    ENTERPRISE: 'Company',
    VAT_E_ORDINARY: 'VAT',
    expressInfo: 'Track',
    expressTel: 'Tel.',
    application: 'Invoice',
    invoiceType_placeholder: 'Please select the types of invoices',
    invoiceTitle_placeholder: 'Please enter the title',
    invoiceTitle_placeholder_name: 'Please enter the name',
    invoiceTitle_placeholder_header: 'Please complete the title',
    taxpayerId_placeholder: 'Please fill in the taxpayer identification number',
    taxpayerId_placeholder_nasuiren: 'Please enter the TIN',
    optional: 'Optional',
    application_confirm: 'Confirm',
    orderNumber: 'Order number',
    price_tip: 'The amount is the actual amount paid, which includes the ticket delivery fee. In case of return or refund, the invoiced amount will be the final amount paid.',
    confirm_text: 'The details cannot be modified after submission. Please double-check.',
    content_tip: 'The details include specific item names and price information. If you have any special needs, please consult the official ticketing hotline.',
    submit: 'Submit',
    back: 'Back',
    confirm: 'Submit',
    details: 'Detail of the invoice',
    repply: 'Re-apply',
    save: 'Save',
    APPLYING: 'Application in progress',
    APPLYING_DESC: 'You can view the Fapiao after the application approval',
    REJECTED: 'Rejected',
    REJECTED_DESC: 'The application has been rejected due to:',
    SUCCESS: 'Issued',
    SUCCESS_DESC: 'Fapiao has been issued',
  },
  system: {
    goHome: 'Back',
    userCenter: 'My Account',
    delete_title: "Are you sure to delete?",
    confirm: "Yes",
    see_agine: "No",
    leftBookPunctuation: "",
    rightBookPunctuation: "",
    title: "Chengdu 2021 FISU Games Official Ticketing",
    wechat: "WeChat",
    alipay: "Alipay",
    money_unit: "CNY ",
    relogin_comment: "Login failed, please log in again.",
  },
  loginModal: {
    title: 'Log In',
    login: 'Log In',
    loging: 'Log In...',
    logout: 'Log Out',
    pleaseEnterCellPhone: 'Please enter the phone number',
    pleaseEnterGoodCellphone: 'Error of the mobile phone number',
    pleaseEnterImageCode: 'Please enter the code',
    pleaseEnterSmsCode: 'Please enter the verification code',
    getSmsCode: 'Get verification code',
    readAgree: 'Please read and agree to the ',
    readAgree2: '',
    pleaseCheckPolicy: 'Please check ',
    confirm: 'Agree',
    notConfirm: 'Disagree',
    and: ' and the ',
  },
  address: {
    add: 'New Address',
    edit: 'Edit',
    delete: 'Delete',
    default: 'Default address',
    no_address: 'No Delivery Address',
    dialog_edit_title: 'New Address',
    dialog_add_title: 'New Address',
    username: 'Recipient',
    cellphone: 'Phone number',
    province: 'Province',
    city: 'City',
    district: 'District',
    detailAddress: 'Detailed address',
    setToDefault: 'Set As Default',
    username_placeholder: 'Please enter the recipient\'s name',
    cellphone_placeholder: 'Please enter the recipient\'s phone number',
    province_placeholder: 'Province',
    city_placeholder: 'City',
    district_placeholder: 'District',
    detailAddress_placeholder: 'Please enter the recipient\'s detailed address',
    detailAddress_rule: 'The address must contain at least 12 characters',
    cellphone_rule: 'Please enter a valid phone number.',
    setToDefault2: 'Set as default',
    delete_dialog_content: 'Are you sure to delete this address?',
  },
  audience: {
    add: 'Add Spectator',
    edit: 'Editing',
    delete: 'Delete',
    no_audience: 'No Spectator',
    dialog_edit_title: 'Edit Spectator',
    dialog_add_title: 'Add Spectator',
    name: 'Name',
    idType: 'ID Document Type',
    idNo: 'ID Document No.',
    name_placeholder: 'Please enter the spectator\'s real name',
    idType_placeholder: 'Please select your ID document type',
    idNo_placeholder: 'Please enter the ID document number',
    know: 'OK',
    attention: 'Real Name Policy',
    attention_text_one: 'By tapping Save, you confirm that you have read and agree to the ',
    attention_text_two: '',
    attention_content: 'In accordance with Chinese Laws and Regulations, Personal Identity Information is required to place an order and purchase tickets. The Personal Identity Information (Including purchaser’s name, ID type, ID number, and etc.) that ticket purchasers provide, subject to applicable laws, will be used by the Chengdu Universiade 2021 Executive Committee in accordance with the terms on Personal Information Protection, for the purchase of the tickets and access to the venue.\nFor a smooth purchase experience, we recommend you complete adding and submitting the purchasers’ personal identity information before continuing the process. \nThe Personal Identity Information that ticket purchasers provide, will be verified by the Chengdu Universiade 2021 Executive Committee for its authenticity and uniqueness.',
    country: 'Country/ Region',
    country_placeholder: 'Please select the country/region',
    delete_dialog_content: 'Are you sure to delete the spectator?',
  },
  hot: {
    main_title: '正在热抢',
    minor_title: '即将开抢',
    support_seat: 'Seat Selection',
    grab_votes: 'Buy now',
    on_sale: 'Sell ticket',
    day: 'day',
  },
  list: {
    no_result_1: 'No search results for',
    no_result_2: '',
    today: 'today',
    main_title: '',
    minor_title: '推荐',
    support_seat: 'Seat Selection',
    grab_votes: 'Buy now',
    on_sale: 'Ticket sales',
    day: 'Day',
    calendar: 'Calendar',
    monday: 'Mon.',
    tuesday: 'Tues.',
    wednesday: 'Wed.',
    thursday: 'Thurs.',
    friday: 'Fri.',
    saterday: 'Sat.',
    sunday: 'Sun.',
  },
  pickseat: {
    text_selected_seats: 'Seats selected',
    btn_text_confirm_seats: 'Confirm',
    text_acmount_to: 'Total',
    text_unit: ' Seats',
    text_count: '',
    text_discount_info: 'Off by',
    btn_text_clear_seats: 'Clear',
    text_discount_title: 'Discount Info',
    btn_text_back:'Return to Global View',
    change_session: 'CHANGE',
    select_default_session: 'Select a session',
    you_selected_seat:'You have selected ',
    combo_unit_name: 'Package',
    ticket_sale_out: 'Sold Out',
    over_limit_num: 'Purchase limit reached'
  },
  content: {
    time: 'Time',
    venue: 'Venue',
    date: 'Date',
    session_name: 'Session',
    ticket_name: 'Price',
    ticket_number: 'Number',
    service_name: 'Services',
    delay_tag: 'DELAY',
    tag_tao: 'Package(s)',
    lack_tag: 'Replenishment',
    has_lacked_tag: 'Replenishment Registered',
    pending_name_tag: 'CREATE REMINDER',
    not_yet_for_sale: 'Not yet on sale',
    has_pending_name_tag: '已设置提醒',
    buy_now: 'BUY NOW',
    go_pick_seat: 'SELECT SEATS',
    show_delay: 'Rescheduled',
    show_has_over: 'Session ended',
    show_has_cancel: 'Session cancelled',
    home: 'Home',
    list: 'List',
    show_detail: 'Details',
    service_name_tips: 'Description',
    event_announcement: 'Notice',
    ticket_purchase_notice: 'Ticketing Instructions',
    observation_tips: 'Instructions for Spectators',
    observation_notice: 'Instructions for Spectators',
    specific_on_site_conditions: 'Subject to the requirements of the venue',
    yuan_unit: '',
    cancel_remind: 'Cancel',
    add_remind: 'Add Reminder',
    day: 'Day',
    success_set_ticket_snatching: 'Completed',
    remind_SMS_5min: 'We will inform you as soon as tickets are replenished.',
    know: 'OK',
    register_success: 'Completed',
    have_ticket_to_notice_first_time: 'We will inform you as soon as tickets are replenished.',
    remind_success: 'Completed',
    sale_ticket_to_notice_first_time: 'We will inform you as soon as tickets are replenished.',
    buy_limition_desc: 'Achieve purchase limit',
    preview_tip: 'Operation Prohibited in Preview Mode'
  },
  confirm: {
    selected_seats: 'Seats selected',
    fill_in_order_information: 'Confirm Order',
    success_submit_order: 'Order placed',
    order_error: 'Failed',
    please_add_address: 'Receiving address',
    confirm_order: 'Your Order Details',
    express_name: 'Delivery fee',
    one_unit: '',
    spectator: ' spectator(s).',
    deliver_method: 'Collection method:',
    deliver_method2: 'Collection method',
    need_add: 'You still need to select  ',
    express_method: 'paper ticket(Courier service)',
    express_unit: 'Delivery fee',
    is_express: 'Deliver to：',
    pay_pirce: 'Payable：',
    sumbit_name: 'SUBMIT',
    real_name_observer: 'Spectator',
    observer: 'Spectator',
    add_observer: 'Add Spectator',
    no_observer: 'No Spectator',
    entry_requires_corresponding_documents: 'spectator(s) selected. Please bring the ID ducoument used for the purchase to enter the venue.',
    selected: '',
    unm_unit: '',
    document_type: 'ID Document Type：',
    identification_number: 'ID Document Number：',
    add_shipping_address: 'New Address',
    no_shipping_address: 'No Delivery Address',
    ticket_collection_instructions: 'Exchange Instructions: ',
    confirm_order_information: 'Order Information',
    amount_to: 'Total',
    caombo_name: 'Package:',
    caombo_discount_name: 'Off by',
    tao_tag: '',
    zhang_tag: ' Tickets',
    tag_all: '',
    slow_ticket_loot: 'Sorry, the ticket has been sold',
    back: 'Back',
    pick_other_seat: 'Please select another seat',
    express_delivery_pay: '',
    scene_pay: '',
    create_order_pay_express_fee: '',
    on_site_receipt_pay_express_fee: '',
  },
  dialog: {
    save: 'Save',
    cancel: 'Cancel',
    aware_and_agree: 'Agree',
    slide_all_text: 'Scroll to read the full text',
  },
  error: {
    error_message: 'Something went wrong. Please try again later',
  },
  ticket_paid: {
    order_success: 'Thank you! The order is paid successfully',
    view_order: 'View Orders',
    order_back: 'Back',
  },
}
